export const CART_TYPE = "notification";

export const ANIMATION_LOAD = "false" === "true";
export const ANIMATION_INTERVAL =
  "interval" === "default" ? 0 : 0.05;
// fade_up, fade_down, fade_in
export const ANIMATION_INTERVAL_STYLE = "fade_up";
